import { NotificationType } from '@/features/notifications/notification-service-extension-shared/constants/firebase'
import {
    AcceptedOrderNotification,
    AwaitingAcceptanceOrderNotification,
    NewOrderNotification,
    Notification,
    PostponedOrderNotification,
} from '@/features/notifications/notification-service-extension-shared/types/firebase'

class NotificationGuard {
    isNotification = (data: any): data is Notification =>
        typeof data === 'object' &&
        data !== null &&
        (typeof data.createdAt === 'number' || /^[0-9]+$/.test(data.createdAt)) &&
        typeof data.type === 'string' &&
        typeof data.uuid === 'string'

    isAwaitingAcceptanceOrder = (data: any): data is AwaitingAcceptanceOrderNotification =>
        this.isNotification(data) &&
        data.type === NotificationType.AwaitingAcceptanceOrder &&
        typeof data.orderChannel === 'string' &&
        (typeof data.orderCustomerName === 'undefined' ||
            typeof data.orderCustomerName === 'string') &&
        typeof data.orderDeliveryTypeCategory === 'string' &&
        typeof data.orderUuid === 'string' &&
        typeof data.orderShortCode === 'string'

    isNewOrder = (data: any): data is NewOrderNotification =>
        this.isAwaitingAcceptanceOrder(data) || this.isAcceptedOrder(data)

    isAcceptedOrder = (data: any): data is AcceptedOrderNotification =>
        this.isNotification(data) &&
        data.type === NotificationType.AcceptedOrder &&
        typeof data.orderChannel === 'string' &&
        (typeof data.orderCustomerName === 'undefined' ||
            typeof data.orderCustomerName === 'string') &&
        typeof data.orderDeliveryTypeCategory === 'string' &&
        typeof data.orderUuid === 'string' &&
        typeof data.orderShortCode === 'string'

    isPostponedOrder = (data: any): data is PostponedOrderNotification =>
        this.isNotification(data) &&
        data.type === NotificationType.PostponedOrder &&
        typeof data.orderUuid === 'string' &&
        typeof data.orderShortCode === 'string'
}

export default new NotificationGuard()
